import { render, staticRenderFns } from "./VodPlayer.vue?vue&type=template&id=e3b32178&scoped=true&"
import script from "./VodPlayer.vue?vue&type=script&lang=js&"
export * from "./VodPlayer.vue?vue&type=script&lang=js&"
import style0 from "./VodPlayer.vue?vue&type=style&index=0&id=e3b32178&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b32178",
  null
  
)

export default component.exports